let variableMap = {
    showPopupAfterQuestion1: false,
}

export function setGlobalKeyValue(key, value) {
    let update = {};
    update[key] = value;
    Object.assign(variableMap, update);
}

export function getGlobalValueOrZero(key) {
    let r = variableMap[key];
    if (!!!r) {
        return 0;
    }
    return r;
}

export function getGlobalValue(key) {
    return getGlobalValueOrZero(key);
}

export function removeGlobalKey(key) {
    delete variableMap[key];
}





